import instance from '../utils/instance';

class RemindConfigService {

    async getRemindList() {
        return await instance.get('/remind/getRemindList');
    }

    async delRemindAfterFirstRemind(uuid) {
        return await instance.delete('/remind/detailRemind?uuid='+uuid);
    }

    async addRemindAfterFirstRemind(type) {
        return await instance.post('/remind/addDetailRemind',{
            type:type
        });
    }

    async setRemindEnable(type,isEnable) {
        return await instance.put('/remind/setRemindEnable?type='+type+'&isEnable='+isEnable);
    }

    async setFirstRemind(type,firstRemind) {
        return await instance.put('/remind/setFirstRemind?type='+type+'&firstRemind='+firstRemind);
    }

    async setRemindWay(type,remindWay) {
        return await instance.put('/remind/setRemindWay?type='+type+'&remindWay='+remindWay);
    }

    async setOverdueRemind(type,overdueRemind) {
        return await instance.put('/remind/setOverdueRemind?type='+type+'&overdueRemind='+overdueRemind);
    }

    async setRemindDistanceDays(uuid,distanceDays) {
        return await instance.put('/remind/setRemindDistanceDays?uuid='+uuid+'&distanceDays='+distanceDays);
    }

    async setRemindPeriod(uuid,period) {
        return await instance.put('/remind/setRemindPeriod?uuid='+uuid+'&period='+period);
    }

    async setRemindValues(type,remindValues) {
        return await instance.put('/remind/setRemindValues?type='+type+'&remindValues='+remindValues);
    }
}

export default new RemindConfigService();